import { useCallback, useEffect, useRef } from 'react'

import useAddEventListener from '@hooks/useAddEventListener'

import SearchResultsHeader from './search-results-header'

import styles from './mobile-bottom-bar.module.scss'

type MobileBottomBarProps = {
  onFiltersButtonClick: () => void
  isVisible: boolean
}

const MobileBottomBar = ({ onFiltersButtonClick, isVisible }: MobileBottomBarProps): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null)
  const setContainerSize = useCallback(() => {
    if (containerRef.current) {
      containerRef.current.style.height = `${window.innerHeight}px`
    }
  }, [containerRef])

  useAddEventListener('resize', setContainerSize)
  useEffect(setContainerSize, [setContainerSize])

  return (
    <div className={styles['full-page-container']} ref={containerRef}>
      <div className={`${styles.wrapper}${isVisible ? ` ${styles['is-visible']}` : ''}`}>
        <SearchResultsHeader onFiltersButtonClick={onFiltersButtonClick} location="mobile-botton-bar" />
      </div>
    </div>
  )
}

export default MobileBottomBar
